// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  api_base_url:
    // 'https://sitaucv2-authadm.metaljunction.com/gateway/orchestrator/',//
    "https://devaucv2-authadm.metaljunction.com/gateway/orchestrator/",
  camundaURL: "https://devaucv2-tptool.metaljunction.com/engine-rest/",
  report_base_url: "https://sitaucv2-report.metaljunction.com/",
  production: false,
  key: {
    pdfViewer:
      "002517bef1884e60bad76017d2ead6b1" /* for Race Admin for mjstore only*/,
  },
  getIpUrl: 'https://api.ipify.org?format=json',
  version: require('../../package.json').version,
  rakAnalyticsBaseUrl: 'https://demoauctionv2-analytics.metaljunction.com/',
  metalAnalyticsBaseUrl: 'https://demo-analytics.metaljunction.com',
  pythonApi: 'https://mtreport-sitanalytics.metaljunction.com/sit/metal/reportAnalysis/',
  RECAPTCHA_V2_KEY: '6LcE1IMpAAAAAInUg3iOzIS8B5Ld26PREBeaBi4O',
  RECAPTCHA_V3_KEY: '6LcE1IMpAAAAAGlY01MMnMXj6_G_STpEaYwXQQif',
  RAKUTEN_SERVICE_VERSION: '1.0.0',
  RAKUTEN_COLLECTOR:
    "https://http-collector-observability.sixthsense.rakuten.com/oap",
  RAKUTEN_SERVICE_NAME: "RACE METAL ADMIN DEV",
  RAKUTEN_AUTH:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZWFtSWQiOiJhYzA1OWVmYS1lOGE3LTQxNDAtOGM5MS03MmQ1NmJiODIwZGUiLCJiaWxsaW5nX2lkIjoiMmYwOWQyNWEtMjAyZS00ODg2LWFjOGYtN2JiZjFmMzI3NDJkIiwiaWF0IjoxNzIxMjc4MDA0LCJhdWQiOiJvYXAiLCJpc3MiOiJzaXh0aC1zZW5zLWF1dGgifQ.dKfdpdpbIxKljvMQflT2OR8MfKctn2HDBvpD89iPWJA",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


